<div class="border-round-3xl flex flex-column align-items-center xl:align-items-start px-5 pt-3 mt-5 pb-5">

    <p-tabView>

      <!-- ATTUALE -->
      <p-tabPanel header="Corrente">

        <p class="flex font-bold text-xl text-center sm:text-start mb-6">DATI SOLLECITO ATTUALE - {{ sollecitoForm.get('annoRiferimento')?.value }}</p>

        <form [formGroup]="sollecitoForm">
          <div class="flex gap-3">

            <div class="dataPickerCustom">
              <span class="p-float-label mb-6">
                <p-calendar
                  formControlName="termineSollecito"
                  dateFormat="dd/mm/yy"
                  inputId="termineSollecito"
                  [iconDisplay]="'input'"
                  [showIcon]="true"></p-calendar>
                <label class="pl-1" for="termineSollecito">Termine Sollecito</label>
              </span>
            </div>

            <div class="">
              <span class="p-float-label mb-6">
                <p-calendar
                  formControlName="termineSollecitoMultiQuota"
                  dateFormat="dd/mm/yy"
                  inputId="termineSollecitoMultiQuota"
                  [iconDisplay]="'input'"
                  [showIcon]="true"></p-calendar>
                <label class="pl-1" for="termineSollecitoMultiQuota">Termine Sollecito Multi-Quota</label>
              </span>
            </div>

            <div class="dataPickerCustom">
              <span class="p-float-label mb-6">
                <p-calendar
                  formControlName="dataConsiglio"
                  dateFormat="dd/mm/yy"
                  inputId="dataConsiglio"
                  [iconDisplay]="'input'"
                  [showIcon]="true"></p-calendar>
                <label class="pl-1" for="dataConsiglio">Data Consiglio</label>
              </span>
            </div>

          </div>
        </form>

        @if (aggiornamentoSpinner) {
          <div class="pl-2 pr-2 pt-1">
            <i class="pi pi-spin pi-cog" style="font-size: 2rem"></i>
          </div>
        }@else {
          <p-button
            label="Aggiorna Sollecito"
            class=""
            (click)="aggiornaSollecito()"
            [disabled]="!role_service.isContabilitaRole() || sollecitoForm.invalid"
          ></p-button>
        }

      </p-tabPanel>

      <!-- LISTA -->
      <p-tabPanel header="Storico">

        <p class="flex font-bold text-xl text-center sm:text-start mb-5">STORICO DATI SOLLECITI</p>

        <p-table [value]="sollecitiStoricoList" [lazy]="true" class="mb-5">

          <!-- headers -->
          <ng-template pTemplate="header">
              <tr>
                <th>Anno Riferimento</th>
                <th>Termine Sollecito</th>
                <th>Termine Sollecito Multi-Quota</th>
                <th>Data Consiglio</th>
              </tr>
          </ng-template>

          <!-- rows -->
          <ng-template pTemplate="body" let-sollecito>
            <tr>
              <td>{{ sollecito.annoRiferimento }}</td>
              <td>{{ sollecito.termineSollecito | date: 'dd/MM/yyyy' }}</td>
              <td>{{ sollecito.termineSollecitoMultiQuota | date: 'dd/MM/yyyy' }}</td>
              <td>{{ sollecito.dataConsiglio | date: 'dd/MM/yyyy' }}</td>
            </tr>
          </ng-template>
        </p-table>

      </p-tabPanel>

    </p-tabView>

  <p-toast position="bottom-center"></p-toast>

</div>
